import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { getSharedConversation } from "~/services/shares";
import { ReadOnlyConversationView } from "./ReadOnlyConversationView";

export const SharedConversationRoute = () => {
  const { token } = useParams<{ token: string }>();

  if (!token) return null;

  return <SharedConversation key={token} token={token} />;
};

interface SharedConversationProps {
  token: string;
}

const SharedConversation = ({ token }: SharedConversationProps) => {
  const fetcher = useCallback(
    (signal: AbortSignal) => getSharedConversation(token, { signal }),
    [token]
  );

  return (
    <ReadOnlyConversationView
      conversationId={null}
      shareToken={token}
      fetcher={fetcher}
      ownerVerb="Shared by"
      notFoundTitle="This shared conversation isn't available"
      notFoundBody="The link may have been revoked, or it never existed."
      readOnlyFeedback
    />
  );
};
